var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo } from 'react';
import { ShareIcon, translate } from '@lucidlink/uicore';
import { NOTIFICATION_EVENT_ACTIONS } from '@lucidlink/workspacemanagement';
import { buildNotificationEventUrl, setWindowLocation } from '#services';
export const useFilespaceSnapshots = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const onOpenInDesktop = useCallback(() => {
        const eventUrl = buildNotificationEventUrl(NOTIFICATION_EVENT_ACTIONS.OpenFilespaceSnapshots, {
            filespaceId,
            workspaceId,
        });
        setWindowLocation(eventUrl);
    }, [filespaceId, workspaceId]);
    const returnValue = useMemo(() => {
        return {
            buttonProps: [
                {
                    'data-testid': 'open-in-desktop',
                    children: translate('Open in Desktop App'),
                    StartIcon: ShareIcon,
                    kind: 'primary',
                    size: 'medium',
                    onClick: onOpenInDesktop,
                },
            ],
        };
    }, [onOpenInDesktop]);
    return returnValue;
};
_react_refresh_temp_1(useFilespaceSnapshots, "2ZuMLLD2G9godF4X/O5x3UdLo4M=");
